import { C as CosmosInput$1, d as defineCustomElement$1 } from './p-DOvrJck5.js';

const CosmosInput = CosmosInput$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosInput, defineCustomElement };
